module.exports = __webpack_public_path__ + "static/media/Desolator.4732971b.png";